import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faExclamationTriangle, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import '../styles/approvaldialog.css';
import Swal from 'sweetalert2';
import { isMobile } from "../utilities/isMobile";

const ApprovalDialog = ({
  isOpen,
  onClose,
  action,
  onSubmit,
  customerName,
  title,
  subtitle,
  placeholder,
  pageType,
  crDuplicateCount = 0,
  crDuplicateCustomers = [],
  vatDuplicateCount = 0,
  vatDuplicateCustomers = [],
  isCompanyModelOpen ,  // Fixed: Added default value
  onContinueWithDuplicates,
  onCancelWithDuplicates,
  t: translateOverride,
}) => {
  const { t } = useTranslation();
  const [comment, setComment] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showDuplicateDetails, setShowDuplicateDetails] = useState(false);

  const hasDuplicates = crDuplicateCount > 0 || vatDuplicateCount > 0;
  const translate = translateOverride || t;
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === 'Go' || e.key === 'Search' || e.key === 'Done') {
      if (isMobile) {
        e.target.blur();
        document.body.classList.remove('keyboard-open');
      }
    }
  };

  const handleSubmit = async () => {
    if (!comment.trim() && ['reject', 'cancel', 'close', 'reassign'].includes(action)) {
      Swal.fire({
        icon: 'warning',
        title: translate('Warning'),
        text: translate('Please provide a reason'),
        confirmButtonText: translate('OK')
      });
      return;
    }

    setIsSubmitting(true);
    try {
      await onSubmit(comment);
      setComment('');
      onClose();
    } catch (error) {
      console.error('Error submitting:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleContinueWithDuplicates = () => {
    if (onContinueWithDuplicates) {
      onContinueWithDuplicates(comment);
    }
    onClose();
  };

  const handleCancelWithDuplicates = () => {
    if (onCancelWithDuplicates) {
      onCancelWithDuplicates();
    }
    onClose();
  };

  // Fixed: Toggle function for showing/hiding duplicate details
  const toggleDuplicateDetails = () => {
    setShowDuplicateDetails(!showDuplicateDetails);
    isCompanyModelOpen()
    
  };

  if (!isOpen) return null;

  const getActionButtonText = () => {
    if (isSubmitting) return translate('Processing...');

    switch (action) {
      case 'approve':
        return translate('Approve');
      case 'reject':
        return translate('Reject');
      case 'cancel':
        return pageType === 'order' ? translate('Cancel Order') : translate('Cancel Ticket');
      case 'close':
        return translate('Close Ticket');
      case 'reassign':
        return translate('Request to Reassign');
      default:
        return translate('Submit');
    }
  };

  const renderDuplicateWarning = () => {
    if (!hasDuplicates) return null;

    return (
      <div className="approval-dialog-duplicate-warning">
        <div className="duplicate-warning-header">
          <FontAwesomeIcon icon={faExclamationTriangle} className="warning-icon" />
          <span className="warning-title">{translate('Duplicate Records Found')}</span>
        </div>
        
        <div className="duplicate-counts">
          {crDuplicateCount > 0 && (
            <div className="duplicate-count-item">
              {/* <span className="count-label">{translate('CR Number')}:</span>
              <span className="count-badge">{crDuplicateCount}</span> */}
     <span className="duplicate-message">
        <strong>{translate("CR Number")}</strong> [{crDuplicateCustomers[0]?.cr_number || 'XXXX'}] {translate("already exists with Customer")} [
        {crDuplicateCustomers[0]?.erp_cust_id ||  crDuplicateCustomers[0]?.id || 'CS-XXXXX'}] —{' '}
        {crDuplicateCustomers[0]?.company_name_en || 
         crDuplicateCustomers[0]?.companyNameEn || 
         'Customer Name'} 
      </span>
  </div>
)}
          {vatDuplicateCount > 0 && (
            <div className="duplicate-count-item">
              {/* <span className="count-label">{translate('VAT Number')}:</span>
              <span className="count-badge">{vatDuplicateCount}</span> */}
      <span className="duplicate-message">
        <strong>{translate("VAT Number")}</strong> [{vatDuplicateCustomers[0]?.vat_number || 'XXXX'}] {translate("already exists with Customer")} [
        {vatDuplicateCustomers[0]?.erp_cust_id ||  vatDuplicateCustomers[0]?.id || 'CS-XXXXX'}] —{' '}
        {vatDuplicateCustomers[0]?.company_name_en || 
         vatDuplicateCustomers[0]?.companyNameEn || 
         'Customer Name'} 
      </span>
  </div>
)}
        </div>
<p>{translate("Please verify before proceeding.")}
      </p>
        {/* Fixed: Proper toggle function */}
        <button 
          className="view-duplicates-btn"
          onClick={toggleDuplicateDetails}
        >
          <FontAwesomeIcon icon={ faEye} />
          {translate('View Duplicates')}
        </button>

        {/* {showDuplicateDetails && (
          <div className="duplicate-details">
            {crDuplicateCustomers.length > 0 && (
              <div className="duplicate-section">
                <h4>{translate('CR Number Duplicates')}</h4>
                {crDuplicateCustomers.map((customer, index) => (
                  <div key={index} className="duplicate-customer-item">
                    <span>{customer.company_name_en || customer.companyNameEn || customer.name || 'N/A'}</span>
                    <span className="customer-id">ID: {customer.id}</span>
                  </div>
                ))}
              </div>
            )}
            {vatDuplicateCustomers.length > 0 && (
              <div className="duplicate-section">
                <h4>{translate('VAT Number Duplicates')}</h4>
                {vatDuplicateCustomers.map((customer, index) => (
                  <div key={index} className="duplicate-customer-item">
                    <span>{customer.company_name_en || customer.companyNameEn || customer.name || 'N/A'}</span>
                    <span className="customer-id">ID: {customer.id}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )} */}

     
      </div>
    );
  };

  return (
    <div className="approval-dialog-overlay" onClick={onClose}>
      <div 
        className="approval-dialog"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="approval-dialog-title"
      >
        <div className="approval-dialog-header">
          <h3 id="approval-dialog-title">{translate(title)}</h3>
          <button className="close-button" onClick={onClose} aria-label={translate('Close')}>
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <div className="approval-dialog-body">
          {customerName && (
            <div className="approval-dialog-customer">
              <span className="customer-label">{translate('Customer')}:</span>
              <span className="customer-name">{customerName}</span>
            </div>
          )}

          {pageType && (
            <div className="approval-dialog-page-type">
              <span className={`page-type-badge ${pageType}`}>
                {pageType === 'order' ? '📦 ' + translate('Order') : '🛠️ ' + translate('Support')}
              </span>
            </div>
          )}

          <p className="approval-dialog-subtitle">{translate(subtitle)}</p>

          {renderDuplicateWarning()}

          <textarea
            className="approval-comment-textarea"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder={translate(placeholder)}
            rows={5}
            onFocus={() => {
              if (window.innerWidth <= 768) {
                document.body.classList.add('keyboard-open');
              }
            }}
            onKeyDown={handleKeyDown}
            onBlur={() => {
              document.body.classList.remove('keyboard-open');
            }}
          />
          
          {comment.length > 0 && (
            <div className="approval-dialog-char-count">
              {comment.length}/500
            </div>
          )}
        </div>

        <div className="approval-dialog-footer">
          <button
            className="cancel-button"
            onClick={onClose}
            disabled={isSubmitting}
          >
            {translate('Cancel')}
          </button>
          <button
            className={`action-button ${action}`}
            onClick={handleSubmit}
            disabled={
              isSubmitting ||
              (['reject', 'cancel', 'close', 'reassign'].includes(action) && !comment.trim())
            }
          >
            {getActionButtonText()}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApprovalDialog;